import React from 'react';
import MainLayout from '../layout/MainLayout';
import Contacts from '../components/Contacts';


const ContactsPage = () => {
    return (
        <MainLayout>
            <Contacts />
        </MainLayout>
    )
}

export default ContactsPage